module.exports = __webpack_public_path__ + "static/img/sandbox-logo.9c18bc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sandbox-logo.png
// module id = Zo4v
// module chunks = 1